import React, { useState, useEffect, useRef, useContext, useMemo, useImperativeHandle } from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
import "./PeerComparison.css";
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";

export default function PeerComparison(props, ref) {

    let navigate = useNavigate();
    let actualData;

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [dataExchange, setExchangeData] = useState("nse");
    const location = useLocation();
    //const { exchg, cocode } = useParams();
    const [data, setData] = useState([]);
    const [exchange, setexchange] = useState(['']);
    let getcompname, getData;
    const childRef = useRef(null);
    const { BaseURL } = useContext(URLstateContext);
    const [currentPage, setCurrentPage] = useState(1);
    let exchg = props.exchange;
    let CoCode = props.coCode;
    //console.log(props.coCode,"props.coCode")
    //console.log(CoCode,"CoCode")
    let PageSize = 7;
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    useEffect(() => {

        const getUrl = BaseURL + "PeerComparison";

        if (props.coCode != "" && props.exchange != "") {

            fetch(`${getUrl}/${exchg}/${CoCode}`)

                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData,"getData")                   
                })
                .catch((error) => {
                });
        }
    }, [props.coCode, props.exchange]);

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    // const routeChange = (event) => {
    //     // const getCoCodeId = event.currentTarget.dataset.id;
    //     // const getDExchange = dataExchange;
    //     // window.open("/CompanySnapshot/" + getDExchange + "/" + getCoCodeId, "_self");

    //     const compcocode = event.currentTarget.dataset.id;
    //     const compcode_array = compcocode.split('-');
    //     //setcocode(compcode_array[1]);
    //    // setcompserachcocode(compcode_array[1]);
    //     //alert("compcode_array[1]:" + compcode_array[1]);
    //    // alert("compserachcocode:"+compserachcocode);
    //     const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and');
    //     const getDExchange = dataExchange;
    //     window.open("/stocks/" + getCoCodeId, "_self");
    // };

   const routeChange = (event) => {
    const compcocode = event.currentTarget.dataset.id;
    //alert("compcode:" + compcocode);
        const compcode_array = compcocode.split('-');         
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '').replace(/\./g,'');
        var data = { "compcode": compcode_array[1], "compname": compcode_array[0] };
        setcocode(compcode_array[1]);
        const getDExchange = dataExchange;
        window.open("/stocks/" + getCoCodeId.toLowerCase(), "_blank");
        //navigate("/stocks/" + getCoCodeId, {
        //state: { id: `${getDExchange}`, coCode: `${getCoCodeId}` },
        //});
    };
    return (
        <section className="peer-sc">
            <div className='container table-boxpeer'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className="mainHeadingGroup">Peer Comparison</h3>
                        <div className="table-responsive">

                            {/* tabIndex={0} updated */}
                            <table className="table table-sm table-striped table-bordered table-hover" tabIndex={0}>

                                <thead className='heading'>

                                    <tr>
                                        <th scope="col">Company Name</th>
                                        <th scope="col">PRICE<span className="muted">(Rs.)</span></th>
                                        <th scope="col">MCAP<span className="muted">(Cr.)</span></th>
                                        <th scope="col">P/B</th>
                                        <th scope="col">P/E<span className="muted">(Rs.)</span></th>
                                        <th scope="col">EPS<span className="muted">(%)</span></th>
                                        <th scope="col">ROE<span className="muted">(%)</span></th>
                                        <th scope="col">ROCE<span className="muted">(%)</span> </th>
                                        <th scope="col">P/S</th>
                                        <th scope="col">EV/EBITDA</th>

                                    </tr>

                                </thead>

                                <tbody>
                                    {currentTableData && currentTableData.map(
                                        ({ co_code, lname, currprice, mcap, Price_BookValue, PriceEarning, PATMargin, EPS, P_S, ROE, ROCE, EV_EBITDA }) => (
                                            <tr className="SameCompPeer ">
                                                <td><h6 className="forhover" onClick={routeChange} data-id={lname + '-' + co_code} id={dataExchange}>{lname} </h6></td>
                                                <td> {(currprice != null) ? currprice.toFixed(2) : currprice = 0}</td>
                                                {/* <td className="Number">{currprice.toFixed(2)}</td> */}
                                                {/* <td className="Number">{mcap.toFixed(2)}</td>
                                    <td className="Number">{Price_BookValue.toFixed(2)}</td>
                                    <td className="Number">{PriceEarning.toFixed(2)}</td>
                                    <td className="Number">{EPS.toFixed(2)}</td>
                                    <td className="Number">{ROE.toFixed(2)}</td>
                                    <td className="Number">{ROCE.toFixed(2)}</td>
                                    <td className="Number">{P_S.toFixed(2)}</td>
                                    <td className="Number">{EV_EBITDA.toFixed(2)}</td> */}
                                                <td> {(mcap != null) ? mcap.toFixed(2) : mcap = 0}</td>
                                                <td> {(Price_BookValue != null) ? Price_BookValue.toFixed(2) : Price_BookValue = 0}</td>
                                                <td> {(PriceEarning != null) ? PriceEarning.toFixed(2) : PriceEarning = 0}</td>
                                                <td> {(EPS != null) ? EPS.toFixed(2) : EPS = 0}</td>
                                                <td> {(ROE != null) ? ROE.toFixed(2) : ROE = 0}</td>
                                                <td> {(ROCE != null) ? ROCE.toFixed(2) : ROCE = 0}</td>
                                                <td> {(P_S != null) ? P_S.toFixed(2) : P_S = 0}</td>
                                                <td> {(EV_EBITDA != null) ? EV_EBITDA.toFixed(2) : EV_EBITDA = 0}</td>

                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                           
                        </div>
                        {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer comp-pagin"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}
                    </div>
                </div>
            </div>
        </section>
    )
}